window.Studio407 = window.Studio407 || {};

(function (Studio) {
  'use strict';

  const DATABASE_NAME = 'Studio407Projects';
  const DATABASE_VERSION = 1;
  const STORE_NAME = 'projects';

  function openDatabase() {
    return new Promise(function (resolve, reject) {
      const request = indexedDB.open(
        DATABASE_NAME,
        DATABASE_VERSION
      );

      request.onupgradeneeded = function (event) {
        const database = event.target.result;

        if (!database.objectStoreNames.contains(STORE_NAME)) {
          database.createObjectStore(STORE_NAME, {
            keyPath: 'projectId'
          });
        }
      };

      request.onsuccess = function () {
        resolve(request.result);
      };

      request.onerror = function () {
        reject(
          request.error ||
          new Error('Could not open the 407 Studio database.')
        );
      };
    });
  }

  function createProjectId() {
    return (
      'studio407-' +
      Date.now() +
      '-' +
      Math.random().toString(36).slice(2, 10)
    );
  }

  function cloneSlotForStorage(slot, index) {
    return {
      id:
        slot && slot.id !== undefined
          ? slot.id
          : index,

      originalFile:
        slot && slot.originalFile
          ? slot.originalFile
          : null,

      finalFile:
        slot && slot.finalFile
          ? slot.finalFile
          : null,

      originalImage:
  slot
    ? (
        slot.uploadedUrl ||
        slot.remoteUrl ||
        slot.existingUrl ||
        (
          typeof slot.originalImage === 'string' &&
          !slot.originalImage.startsWith('blob:')
            ? slot.originalImage
            : null
        )
      )
    : null,

      image:
  slot
    ? (
        slot.uploadedUrl ||
        slot.remoteUrl ||
        slot.existingUrl ||
        (
          typeof slot.image === 'string' &&
          !slot.image.startsWith('blob:')
            ? slot.image
            : null
        )
      )
    : null,

      existingUrl:
        slot && slot.existingUrl
          ? slot.existingUrl
          : null,

      remoteUrl:
        slot && slot.remoteUrl
          ? slot.remoteUrl
          : null,

      uploadedUrl:
        slot && slot.uploadedUrl
          ? slot.uploadedUrl
          : null,

      cropData:
        slot && slot.cropData
          ? slot.cropData
          : null,

      canvasData:
        slot && slot.canvasData
          ? slot.canvasData
          : null,

      imageData:
        slot && slot.imageData
          ? slot.imageData
          : null,

      containerData:
        slot && slot.containerData
          ? slot.containerData
          : null,

      rotation:
        slot && Number.isFinite(slot.rotation)
          ? slot.rotation
          : 0,

      zoom:
        slot && Number.isFinite(slot.zoom)
          ? slot.zoom
          : 1,

      edited:
        Boolean(slot && slot.edited),

      changed:
        Boolean(slot && slot.changed),

      replaced:
        Boolean(slot && slot.replaced)
    };
  }

  function restoreSlotFromStorage(savedSlot, index) {
  const originalFile =
    savedSlot && savedSlot.originalFile
      ? savedSlot.originalFile
      : null;

  const finalFile =
    savedSlot && savedSlot.finalFile
      ? savedSlot.finalFile
      : null;

  const existingUrl =
    savedSlot
      ? (
          savedSlot.uploadedUrl ||
          savedSlot.remoteUrl ||
          savedSlot.existingUrl ||
          null
        )
      : null;

  /*
   * Nunca reutilizar un blob: guardado anteriormente.
   * Creamos una URL local nueva desde el File persistido
   * en IndexedDB.
   */
  const localOriginalImage =
    originalFile instanceof Blob
      ? URL.createObjectURL(originalFile)
      : null;

  const localFinalImage =
    finalFile instanceof Blob
      ? URL.createObjectURL(finalFile)
      : null;

  const safeSavedImage =
    savedSlot &&
    typeof savedSlot.image === 'string' &&
    !savedSlot.image.startsWith('blob:')
      ? savedSlot.image
      : null;

  const safeOriginalImage =
    savedSlot &&
    typeof savedSlot.originalImage === 'string' &&
    !savedSlot.originalImage.startsWith('blob:')
      ? savedSlot.originalImage
      : null;

  return {
    id:
      savedSlot && savedSlot.id !== undefined
        ? savedSlot.id
        : index,

    originalFile: originalFile,
    finalFile: finalFile,

    originalImage:
      localOriginalImage ||
      safeOriginalImage ||
      existingUrl ||
      null,

    image:
      localFinalImage ||
      localOriginalImage ||
      safeSavedImage ||
      existingUrl ||
      null,

    existingUrl: existingUrl,
    remoteUrl: existingUrl,
    uploadedUrl: existingUrl,

    cropData:
      savedSlot && savedSlot.cropData
        ? savedSlot.cropData
        : null,

    canvasData:
      savedSlot && savedSlot.canvasData
        ? savedSlot.canvasData
        : null,

    imageData:
      savedSlot && savedSlot.imageData
        ? savedSlot.imageData
        : null,

    containerData:
      savedSlot && savedSlot.containerData
        ? savedSlot.containerData
        : null,

    rotation:
      savedSlot && Number.isFinite(savedSlot.rotation)
        ? savedSlot.rotation
        : 0,

    zoom:
      savedSlot && Number.isFinite(savedSlot.zoom)
        ? savedSlot.zoom
        : 1,

    edited:
      Boolean(savedSlot && savedSlot.edited),

    changed: false,
    replaced: false
  };
}

  Studio.saveCartEditorProject = async function (options) {
    const settings = options || {};
    const database = await openDatabase();

    const currentProjectId =
      settings.projectId ||
      (
        Studio.state &&
        Studio.state.projectId
          ? Studio.state.projectId
          : null
      );

    const projectId =
      currentProjectId || createProjectId();

    const project = {
      projectId: projectId,

      lineKey:
        settings.lineKey ||
        (
          Studio.state &&
          Studio.state.editLineKey
            ? Studio.state.editLineKey
            : null
        ),

      variantId:
        Number(
          settings.variantId ||
          (
            Studio.state &&
            Studio.state.editVariantId
              ? Studio.state.editVariantId
              : Studio.getSelectedVariantId()
          )
        ) || null,

      setSize:
        Number(
          settings.setSize ||
          (
            Studio.state
              ? Studio.state.setSize
              : 0
          )
        ) || 0,

      slots:
        Studio.state.slots.map(function (slot, index) {
          return cloneSlotForStorage(slot, index);
        }),

      createdAt:
        settings.createdAt || Date.now(),

      updatedAt:
        Date.now()
    };

    await new Promise(function (resolve, reject) {
      const transaction = database.transaction(
        STORE_NAME,
        'readwrite'
      );

      const store = transaction.objectStore(STORE_NAME);
      const request = store.put(project);

      request.onsuccess = function () {
        resolve();
      };

      request.onerror = function () {
        reject(
          request.error ||
          new Error('Could not save the 407 Studio project.')
        );
      };
    });

    database.close();

    Studio.state.projectId = projectId;

    return project;
  };

  Studio.getCartEditorProject = async function (projectId) {
    if (!projectId) {
      return null;
    }

    const database = await openDatabase();

    const project = await new Promise(function (resolve, reject) {
      const transaction = database.transaction(
        STORE_NAME,
        'readonly'
      );

      const store = transaction.objectStore(STORE_NAME);
      const request = store.get(projectId);

      request.onsuccess = function () {
        resolve(request.result || null);
      };

      request.onerror = function () {
        reject(
          request.error ||
          new Error('Could not load the 407 Studio project.')
        );
      };
    });

    database.close();

    return project;
  };

  Studio.restoreCartEditorProject = async function (projectId) {
    const project =
      await Studio.getCartEditorProject(projectId);

    if (!project) {
      return false;
    }

    Studio.state.projectId = project.projectId;
    Studio.state.setSize = Number(project.setSize) || 0;
    Studio.state.editLineKey = project.lineKey || null;
    Studio.state.editVariantId =
      Number(project.variantId) || null;

    Studio.state.isEditingCartItem =
      Boolean(project.lineKey);

    Studio.state.slots = project.slots.map(
      function (savedSlot, index) {
        return restoreSlotFromStorage(
          savedSlot,
          index
        );
      }
    );

    return true;
  };

  Studio.updateCartEditorProjectLineKey =
    async function (projectId, lineKey) {
      if (!projectId || !lineKey) {
        return false;
      }

      const project =
        await Studio.getCartEditorProject(projectId);

      if (!project) {
        return false;
      }

      project.lineKey = lineKey;
      project.updatedAt = Date.now();

      const database = await openDatabase();

      await new Promise(function (resolve, reject) {
        const transaction = database.transaction(
          STORE_NAME,
          'readwrite'
        );

        const store = transaction.objectStore(STORE_NAME);
        const request = store.put(project);

        request.onsuccess = function () {
          resolve();
        };

        request.onerror = function () {
          reject(
            request.error ||
            new Error(
              'Could not update the 407 Studio project.'
            )
          );
        };
      });

      database.close();

      return true;
    };

  Studio.deleteCartEditorProject =
    async function (projectId) {
      if (!projectId) {
        return false;
      }

      const database = await openDatabase();

      await new Promise(function (resolve, reject) {
        const transaction = database.transaction(
          STORE_NAME,
          'readwrite'
        );

        const store = transaction.objectStore(STORE_NAME);
        const request = store.delete(projectId);

        request.onsuccess = function () {
          resolve();
        };

        request.onerror = function () {
          reject(
            request.error ||
            new Error(
              'Could not delete the 407 Studio project.'
            )
          );
        };
      });

      database.close();

      return true;
    };

  Studio.getCartEditorProjectId =
    function () {
      if (
        Studio.state &&
        Studio.state.projectId
      ) {
        return Studio.state.projectId;
      }

      const editSession =
        typeof Studio.getEditSession === 'function'
          ? Studio.getEditSession()
          : null;

      return editSession && editSession.projectId
        ? editSession.projectId
        : null;
    };
})(window.Studio407);